import { CSSProperties, useCallback, useState } from 'react';
import { autoUpdate, flip, offset, Strategy, useFloating } from '@floating-ui/react-dom';

export type UseConfirmPopoverProps = {
  isOpen?: boolean;
  setIsOpen: (isOpen: boolean) => void;
  style: CSSProperties;
  floatingRef: (node: HTMLElement | null) => void;
};
export function useConfirmPopover({ strategy }: { strategy?: Strategy } = {}) {
  const [isOpen, setIsOpen] = useState(false);
  const floating = useFloating({
    placement: 'bottom-end',
    strategy,
    whileElementsMounted: autoUpdate,
    // Поповер специально подвинут, чтобы перекрывать начальный элемент. Может не всегда работать, надо подумать
    middleware: [flip(), offset(-40)],
  });

  return {
    anchorRef: floating.refs.setReference,
    open: useCallback(() => setIsOpen(true), [setIsOpen]),
    props: {
      isOpen,
      setIsOpen,
      style: floating.floatingStyles,
      floatingRef: floating.refs.setFloating,
    },
  };
}
